/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Verified.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Verified: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" ref={ref} {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M13.18 22.782a2.7 2.7 0 0 0 1.04.208l.01.01c.91 0 1.8-.467 2.29-1.291l.79-1.322a.66.66 0 0 1 .42-.307l1.51-.338c1.3-.288 2.18-1.5 2.06-2.821l-.14-1.53a.64.64 0 0 1 .16-.497l1.02-1.152c.88-.993.88-2.493 0-3.487l-1.02-1.152a.65.65 0 0 1-.16-.497l.14-1.53a2.636 2.636 0 0 0-2.06-2.82l-1.51-.338a.66.66 0 0 1-.42-.308l-.79-1.321a2.675 2.675 0 0 0-3.34-1.073l-1.42.606a.67.67 0 0 1-.52 0l-1.42-.606a2.68 2.68 0 0 0-3.34 1.063L5.69 3.6a.63.63 0 0 1-.42.308l-1.51.338c-1.3.288-2.18 1.5-2.06 2.82l.14 1.53a.65.65 0 0 1-.16.497L.66 10.245a2.63 2.63 0 0 0 0 3.487l1.02 1.152c.12.14.18.318.16.497l-.14 1.53a2.636 2.636 0 0 0 2.06 2.82l1.51.339c.17.04.33.149.42.308l.79 1.32a2.67 2.67 0 0 0 3.34 1.084l1.42-.607a.68.68 0 0 1 .52 0zm3.027-12.577a1 1 0 0 0-1.414-1.415L10 13.583 8.207 11.79a1 1 0 1 0-1.414 1.415l2.5 2.5a1 1 0 0 0 1.414 0z"
      clipRule="evenodd"
    />
  </svg>
);
Verified.displayName = "Verified";
